import { render, staticRenderFns } from "./InstanceSetting.vue?vue&type=template&id=01a66909&scoped=true"
import script from "./InstanceSetting.vue?vue&type=script&lang=js"
export * from "./InstanceSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a66909",
  null
  
)

export default component.exports